import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { SummaryCard } from "../../components/StyledComponent";
import { useSelector } from "react-redux";

const Step4 = ({ formData, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = () => {
    handleTabChange(4);
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Fee Details</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Builtup Area:</b> (SQM)
                      <br />
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.totalBuildUpArea}</td>
                  </tr>
                  
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Fee:</b> (₹)
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.estimateAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(3)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};
export default Step4;
